import axios from 'axios';
import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './Esim.css';

function Esim() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);
  const [msisdn, setMsisdn] = useState('');
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [mostrarCampo, setMostrarCampo] = useState(false);
  const [comentario, setComentario] = useState('');
  const [mail, setMail] = useState('');
  const [msisdnported, setMsisdnported] = useState('');
  const [vendedor, setVendedor] = useState(null);

  React.useEffect(() => {
    const idv = localStorage.getItem('id_vendedor');
    const nombre = localStorage.getItem('nombre');
    if (idv && idv !== 'undefined' && idv !== 'null') {
      setVendedor({ id: idv, nombre: nombre || '' });
    }
  }, []);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleChange2 = (e) => setSelectedOption(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) {
      toast.warn('Por favor ingresa tu dispositivo', { autoClose: 2000 });
      return;
    }
    setIsLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}/prod/esimconsulta`, { device: formData.name, app: '1' });
      setApiData(response.data);
      const data = response.data;
      setOptions(Array.isArray(data) ? data : Array.isArray(data.body) ? data.body : Array.isArray(data.data) ? data.data : [data]);
      setMsisdn(data.msisdn || '');
      toast.success('Dispositivo consultado correctamente', { autoClose: 2000 });
    } catch (err) {
      toast.error('Error al consultar dispositivo', { autoClose: 3000 });
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit3 = (e) => {
    e.preventDefault();
    if (!selectedOption || !mail) {
      toast.warn('Selecciona un dispositivo y proporciona tu correo', { autoClose: 2000 });
      return;
    }
    const data = {
      msisdn,
      id_oferta: selectedOption,
      movil: msisdnported,
      mail,
      nip: comentario,
      app: '1',
      id_vendedor: localStorage.getItem('id_vendedor') || '',
    };
    localStorage.setItem('formData', JSON.stringify(data));
    toast.success('¡Estamos preparando tu compra!', { autoClose: 2000 });
    navigate('/Ofertaesim');
  };

  return (
    <div className="esim-page">
      <div className="esim-container">

        {/* VENDEDOR BAR */}
        {vendedor && (
          <div style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            padding: '10px 16px', background: '#fff', borderRadius: '12px',
            marginBottom: '12px', border: '1px solid #d4e8d6', fontSize: '13px',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '16px' }}>👤</span>
              <div>
                <div style={{ fontWeight: 700, color: '#1a3a2a' }}>{vendedor.nombre}</div>
                <div style={{ fontSize: 11, color: '#6b8f71' }}>ID: {vendedor.id}</div>
              </div>
            </div>
          </div>
        )}

        {/* HERO */}
        <div className="esim-hero">
          <span className="esim-hero-badge">eSIM MonkeyPhone</span>
          <h1>Tu línea móvil sin chip físico</h1>
          <p>
            Activa tu eSIM MonkeyPhone en minutos. Sin tiendas, sin esperas,
            directo a tu correo. Compatible con los principales dispositivos.
          </p>
          <div className="esim-trust">
            <div className="esim-trust-item">📱 Sin chip físico</div>
            <div className="esim-trust-item">📧 Recíbela por correo</div>
            <div className="esim-trust-item">🔄 Porta tu número</div>
          </div>
        </div>

        {/* CÓMO FUNCIONA */}
        <div className="esim-how">
          <h2 className="esim-how-title">¿Cómo funciona?</h2>
          <div className="esim-how-grid">
            <div className="esim-how-card">
              <div className="esim-how-icon">📱</div>
              <h3>1. Verifica tu dispositivo</h3>
              <p>Busca tu modelo para confirmar compatibilidad con eSIM.</p>
            </div>
            <div className="esim-how-card">
              <div className="esim-how-icon">📧</div>
              <h3>2. Ingresa tu correo</h3>
              <p>Te enviaremos el QR de tu eSIM para que la instales.</p>
            </div>
            <div className="esim-how-card">
              <div className="esim-how-icon">✅</div>
              <h3>3. Activa y listo</h3>
              <p>Escanea el QR desde tu teléfono y empieza a navegar.</p>
            </div>
          </div>
        </div>

        {/* Paso 1: Consulta */}
        <form onSubmit={handleSubmit} className="esim-step">
          <div className="step-header">
            <div className="step-number">1</div>
            <p className="step-title">Consulta tu Dispositivo</p>
          </div>
          <input
            className="esim-input"
            type="text"
            name="name"
            placeholder="Ej: iPhone 15, Samsung S24..."
            value={formData.name}
            onChange={handleChange}
          />
          <button className="esim-btn" disabled={isLoading}>
            {isLoading ? 'Consultando...' : 'Buscar'}
          </button>
        </form>

        {error && <p className="esim-error">{error}</p>}

        {/* Paso 2: Selección */}
        {apiData && (
          <div className="esim-step">
            <div className="step-header">
              <div className="step-number">2</div>
              <p className="step-title">Escoge tu Dispositivo</p>
            </div>
            <select
              className="esim-select"
              value={selectedOption}
              onChange={handleChange2}
            >
              <option value="">-- Selecciona dispositivo --</option>
              {options.map((item) => (
                <option key={item.modelo} value={item.modelo}>
                  {item.modelo} {item.fabricante}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Paso 3: Correo y compra */}
        {apiData && (
          <div className="esim-step">
            <div className="step-header">
              <div className="step-number">3</div>
              <p className="step-title">Ingresa tu Correo</p>
            </div>
            <input
              className="esim-input"
              type="email"
              placeholder="tucorreo@ejemplo.com"
              value={mail}
              onChange={(e) => setMail(e.target.value)}
            />

            <label className="port-toggle">
              <input
                type="checkbox"
                checked={mostrarCampo}
                onChange={(e) => setMostrarCampo(e.target.checked)}
              />
              <span>¿Quieres portar tu línea?</span>
            </label>

            {mostrarCampo && (
              <div className="port-fields">
                <input
                  type="number"
                  placeholder="NIP de portabilidad"
                  value={comentario}
                  onChange={(e) => setComentario(e.target.value)}
                  className="esim-input"
                />
                <input
                  type="number"
                  placeholder="Número a portar"
                  value={msisdnported}
                  onChange={(e) => setMsisdnported(e.target.value)}
                  className="esim-input"
                />
              </div>
            )}

            <button className="esim-btn" onClick={handleSubmit3} disabled={isLoading}>
              {isLoading ? 'Procesando...' : 'Continuar con la compra'}
            </button>
          </div>
        )}
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default Esim;
